import { config } from '../config';

const zoneApi = `${config.url.API_BASE_URL}/zones`;

export const getNeighborOfCity = async () => {
  const url = `${zoneApi}`;
  const results = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  }) .then((response) => response.json())
    .catch((err) => {
      console.log('failed to get neighbor of city', err.message);
    });
  return results;
};